// extracted by mini-css-extract-plugin
export default {"container":"switch_container__EhcQR","input":"switch_input__OeLsr","label":"switch_label__SX1mI"};